import { MenuItem } from "./types";
import AnalyticsIcon from '../assets/icons/analytics_download.png';
import experienceIcon from '../assets/icons/experience_download.png';
import bvaIcon from '../assets/icons/bvaIcon.png'
import toolsIcon from '../assets/icons/tools__download.png'
import AgencyRoasterIcon from '../assets/icons/agency-roaster.png'
import tipsNtrickIcon from '../assets/icons/tip_and_tricks_download.png'
import workfrontIcon from '../assets/icons/adobeWorkfront.png'
import faqIcon from '../assets/icons/faq_download.png'
import markcapsIcon from '../assets/icons/markcaps_download.png'
import persistentPlatformIcon from '../assets/icons/marketing_persisitenctplatform_download.png'
import marketingoverviewIcon from '../assets/icons/marketingoverview_download.png'
import nmaIcon from '../assets/icons/nma_download.png'
import prioritizationProcessIcon from '../assets/icons/prioritization_process.png'
import InnovationProcessIcon from '../assets/icons/InnovationProcess.png'
import MDLIcon from '../assets/icons/mdl-icon.png'
import MediaIcon from '../assets/icons/media-icon.svg'
import MediaIcon2 from '../assets/icons/media-icon-2.svg'
import COPIcon from '../assets/icons/communities-of-practitioners.png'

export const menu: MenuItem[] = [
  {
    id: "mywork",
    label: "My Work",
    children: [
      // {
      //   id: "create-brief",
      //   label: "Create a Brief",
      //   children: [
      //     {
      //       id: "campaign",
      //       label: "Campaign Brief",
      //       icon: createBriefIcon,
      //       path: "/campaign",
      //     },
      //   ],
      // },
      {
        id: "adobe",
        label: "Adobe Workfront",
        children: [
          {
            id: "workfront",
            label: "Adobe Workfront",
            icon: workfrontIcon,
            external: true,
            path: "https://cocacoladigital.sb02.workfront.com/",
          },
          {
            id: "project",
            label: "Project Request",
            icon: workfrontIcon,
            external: true,
            path: "https://cocacoladigital.sb02.workfront.com/requests/",
          },
          {
            id: "dashboard",
            label: "Prioritization Dashboard",
            icon: workfrontIcon,
            external: true,
            path: "https://cocacoladigital.sb02.workfront.com/dashboard/65bd0f75003649bec98a82bf05f18e84/detail",
          },
        ],
      },
      // {
      //   id: "Match&Thrive",
      //   label: "Match & Thrive",
      //   children: [
      //     {
      //       id: "projectBlueprint",
      //       label: "Project Blueprint",
      //       icon: match_and_thriveIcon,
      //       path: "",
      //     },
      //     {
      //       id: "openProject",
      //       label: "Open Project",
      //       icon: match_and_thriveIcon,
      //       path: "",
      //     },
      //     {
      //       id: "projectStaffing",
      //       label: "Project Staffing",
      //       icon: match_and_thriveIcon,
      //       path: "",
      //     },
      //      {
      //       id: "teamRecommendations",
      //       label: "Team Recommendations",
      //       icon: match_and_thriveIcon,
      //       path: "",
      //     },
      //      {
      //       id: "predictor",
      //       label: "Predictor",
      //       icon: match_and_thriveIcon,
      //       path: "",
      //     },
      //   ],
      // },
      // {
      //   id: "contentManagement",
      //   label: "Content Management",
      //   children: [
      //     {
      //       id: "assetsManager",
      //       label: "Assets Manager",
      //       icon: assetmanagerIcon,
      //       path: "/brief-status",
      //     },
      //   ],
      // },
    ],
  },
  {
    id: "marketing",
    label: "Marketing",
    children: [
      {
        id: "marketing-main",
        label: "",
        children: [
          {
            id: "overview",
            label: "Marketing Overview",
            icon: marketingoverviewIcon,
            path: "/our-work",
          },
          {
            id: "capabilities",
            label: "Marketing Capabilities Hub",
            icon: markcapsIcon,
            path: "/marketing-capabilities",
          },
          {
            id: "prioritization",
            label: "Prioritization Process",
            icon: prioritizationProcessIcon,
            path: "/prioritization-process",
          },
          {
            id: "innovation",
            label: "Innovation Process",
            icon: InnovationProcessIcon,
            path: "/innovation-process",
          },
          {
            id: "platform",
            label: "Persistent Platform",
            icon: persistentPlatformIcon,
            path: "/persistent-platform",
          },
          {
            id: "bva",
            label: "BVA",
            icon: bvaIcon,
            path: "/bva",
          },
          {
            id: "experience-loop",
            label: "Experience Loop Process",
            icon: experienceIcon,
            path: "/experience-loop-process",
          },
        ],
      },

      // 👇 Second section
      {
        id: "experience-loop-section",
        label: "Experience Loop",
        children: [
          {
            id: "assemble",
            label: "Assemble",
            icon: experienceIcon,
            path: "/experience-loop-process/page-assemble",
          },
          {
            id: "explore",
            label: "Explore",
            icon: experienceIcon,
            path: "/experience-loop-process/page-explore",
          },
          {
            id: "create",
            label: "Create",
            icon: experienceIcon,
            path: "/experience-loop-process/page-create",
          },
          {
            id: "shape",
            label: "Shape",
            icon: experienceIcon,
            path: "/experience-loop-process/page-shape",
          },
          {
            id: "produce",
            label: "Produce",
            icon: experienceIcon,
            path: "/experience-loop-process/page-produce",
          },
          {
            id: "learn",
            label: "Learn",
            icon: experienceIcon,
            path: "/experience-loop-process/page-learn",
          },
        ],
      },
    ],
  },
  {
    id: "tools",
    label: "Tools & Support",
    children: [
      // SECTION 1 (no header in UI)
      {
        id: "tools-main",
        label: "", // no visible title (as per your UI)
        children: [
          {
            id: "cop",
            label: "Communities Of Practitioners",
            path: "/communities-of-practitioners",
            icon: COPIcon,
          },
          {
            id: "tools-support",
            label: "Tools and Support",
            path: "/tools-and-support",
            icon: toolsIcon,
          },
          {
            id: "tips",
            label: "Tips & Tricks",
            icon: tipsNtrickIcon,
            path: "/onboarding",
          },
          {
            id: "agency-roster",
            label: "Agency Roster",
            icon: AgencyRoasterIcon,
            path: "/agency-roster",
          },
        ],
      },

      // SECTION 2 (with header + description)
      {
        id: "tools-section",
        label: "Tools",
        subheader: "Find and use the best-in-class tools available to you",
        children: [
          {
            id: "workfront",
            label: "Adobe Workfront",
            path: "https://experience.adobe.com/#/@cocacola/so:cocacoladigital-Sandbox2/workfront/home/workspaces",
            external: true,
            icon: workfrontIcon,
          },
          {
            id: "faq",
            label: "FAQ",
            path: "/faqs",
            icon: faqIcon,
          },
        ],
      },
    ],
  },
  {
    id: "analytics",
    label: "Analytics",
    children: [
      {
        id: "analytics-inner",
        label: "",
        children: [
          {
            id: "prioritization-action",
            label: "Prioritization Action",
            icon: workfrontIcon,
            path: "https://experience.adobe.com/#/@cocacola/so:cocacoladigital-Sandbox2/workfront/dashboard/65bd0f75003649bec98a82bf05f18e84/detail",
            external: true,
          },
          {
            id: "innovation-pipeline",
            label: "Innovation Pipeline",
            icon: AnalyticsIcon,
            path: "/innovation-pipeline",
            iframeUrl:
              "https://app.powerbi.com/reportEmbed?reportId=30bddfaa-42e3-4316-afda-fb5c3878b644&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c",
          },
          {
            id: "innovation-effectiveness",
            label: "Innovation Effectiveness",
            icon: AnalyticsIcon,
            path: "/innovation-effectiveness",
            iframeUrl:
              "https://app.powerbi.com/reportEmbed?reportId=1d723af6-e716-4b0d-9470-ca14b51fbebf&appId=1636ddad-b904-480d-be15-d3aa54b824ac&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c",
          },
          {
            id: "gate-meetings",
            label: "Gate Meetings",
            icon: workfrontIcon,
            external: true,
            path: "https://experience.adobe.com/#/@cocacola/so:cocacoladigital-Sandbox2/workfront/dashboard/62fd157a003756ab0c674323e78b9407/detail",
          },
          {
            id: "ideation-fast-start",
            label: "Ideation - Fast Start",
            icon: AnalyticsIcon,
            path: "/ideation-fast-start",
            iframeUrl:
              "https://app.powerbi.com/reportEmbed?reportId=8fd083b8-8f08-45e6-873d-fd0f354b750a&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c",
          },
        ],
      },
      {
        id: "media-data",
        label: "Media Data",
        children: [
          {
            id: "mdl-dashboards",
            label: "MDL Dashboards",
            icon: MDLIcon,
            path: "/mdl-dashboards",
            iframeUrl:
              "https://app.powerbi.com/reportEmbed?reportId=3b9aa7bd-9ac4-43a0-819e-d15fc5142b24&appId=c5f8e1de-007e-44d5-9280-14eb2389636c&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c",
          },
          {
            id: "media-modeling-engine",
            label: "Media Modeling Engine",
            icon: MediaIcon,
            path: "/media-modeling-engine",
            iframeUrl:
              "https://emrapidmodelling.essencemediacom.com/tccc-pitch-test/overview",
          },
          {
            id: "media-data-ai",
            label: "Media Data AI",
            icon: MediaIcon,
            path: "/media-data-ai",
            iframeUrl: "https://mediabrain-tccc-prototype-test.satalia.io/chat",
          },
          {
            id: "media-data-ai-questions",
            label: "Media Data AI questions",
            icon: MediaIcon2,
            path: "/media-data-ai-questions",
            iframeUrl: "https://miro.com/app/live-embed/uXjVLgWhEYk=/",
          },
        ],
      },
    ],
  },
  {
    id: "nma",
    label: "Networked Marketing Awards",
    children: [
      {
        id: "nma-inner",
        label: "",
        children: [
          {
            id: "nma-home",
            label: "NMA Home",
            icon: nmaIcon,
            path: "/nma-home",
          },
          {
            id: "nma-2025-gallery",
            label: "NMA Gallery",
            icon: nmaIcon,
            path: "/nma-gallery",
          },
        ],
      },
    ],
  },
  /* this is a commented-out section of the menu that is not currently being used.*/
  // {
  //   id: "Commerce",
  //   label: "Commerce",
  //   children: [
  //     {
  //       id: "Commerce-inner",
  //       label: "",
  //       children: [
  //         {
  //           id: "360IAProcess",
  //           label: "360 IA Process",
  //           icon: IAProcessIcon,
  //         },
  //         {
  //           id: "retailIndiaNetworkIntelligence",
  //           label: "Retail India Network Intelligence",
  //           icon: RetailMediaNetworkIntelligenceIcon,
  //         },
  //       ],
  //     },
  //   ],
  // },
];